import Image from 'next/image';
import LinkNoPrefetch from '@/components/link-noprefetch';

function getIndustryLabel(industry) {
    if (!Array.isArray(industry) || industry.length === 0) return null;
    const first = industry[0];
    if (typeof first === 'string') return first;
    if (first && typeof first === 'object') {
        const [value] = Object.values(first);
        return value ?? null;
    }
    return null;
}

function CaseStudy({ attrs, node }) {
    const data = attrs?.data ?? node?.attrs?.data;
    if (!data) return null;

    const { heading, urlTitle, image, industry, client } = data;
    if (!urlTitle) return null;

    const industryLabel = getIndustryLabel(industry);
    const clientName =
        Array.isArray(client) && client[0]
            ? client[0].title || client[0].name || client[0].clientName
            : null;
    const href = `/case-studies/${urlTitle}`;

    return (
        <LinkNoPrefetch href={href} className="not-prose group my-8 block">
            <div className="flex flex-col gap-4 rounded-2xl border border-blue-200 bg-white p-4 shadow-sm transition-shadow hover:shadow-md md:flex-row md:items-center md:gap-6 md:p-6">
                {image && (
                    <div className="relative aspect-video w-full shrink-0 md:aspect-[4/3] md:w-2/5">
                        <Image
                            src={image}
                            alt={heading || 'Case study'}
                            className="rounded-xl object-contain"
                            quality={70}
                            fill
                            sizes="(max-width: 768px) calc(100vw - 64px), 400px"
                        />
                    </div>
                )}
                <div className="flex flex-1 flex-col gap-3 px-2 pb-2 md:px-0 md:pb-0">
                    <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-fuschia-700">
                        <span>Case Study</span>
                        {industryLabel && (
                            <>
                                <span className="text-blue-300">•</span>
                                <span className="text-blue-500">{industryLabel}</span>
                            </>
                        )}
                    </div>
                    {clientName && (
                        <p className="text-sm font-semibold text-blue-500">{clientName}</p>
                    )}
                    {heading && (
                        <h3 className="m-0 text-xl font-semibold tracking-tight text-blue-700 group-hover:underline md:text-2xl">
                            {heading}
                        </h3>
                    )}
                    <span className="mt-2 text-sm font-semibold text-primary">
                        Read the case study →
                    </span>
                </div>
            </div>
        </LinkNoPrefetch>
    );
}

export default CaseStudy;
